import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Header from './components/header';
import Header1 from './components/Header1';
import Home from './components/Home';
// import Features from './components/features';
import './App.css';
import Features1 from './components/Features1';
import Advantages1 from './components/Advantages1';
// import Advantages from './components/advantages';
// import FAQ from './components/FAQ';
import FAQ1 from './components/FAQ1';
import BBPS from './components/BBPS';
import Footer from './components/Footer';
import Disclaimer from './components/Disclaimer';
import Terms from './components/Terms';
import Privacy from './components/Privacy';

// Layout component that includes all sections for the home page
const HomeLayout = () => {
  return (
    <>
      <section id="home">
        <Home />
      </section>
      <section id="features">
        <Features1 />
      </section>
      <section id="advantages">
        <Advantages1 />
      </section>
      <section id="faq">
        <FAQ1 />
      </section>
      <section id="bbpsPoints">
        <BBPS />
      </section>
      <section id="footer">
        <Footer />
      </section>
    </>
  );
};

function App() {
  return (
    <Router>
      <Header1 />
      <Routes>
        <Route path="/" element={<HomeLayout />} />
        <Route path="/features" element={<Navigate to="/#features" replace />} />
        <Route path="/advantages" element={<Navigate to="/#advantages" replace />} />
        <Route path="/faq" element={<Navigate to="/#faq" replace />} />
        <Route path="/bbpsPoints" element={<Navigate to="/#bbpsPoints" replace />} />
        <Route path="/footer" element={<Navigate to="/#footer" replace />} />
        
        {/* Keep separate pages for legal content */}
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        
        {/* Catch all other routes */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
